import { render, staticRenderFns } from "./WorkshopsView.vue?vue&type=template&id=75c68fd1&"
import script from "./WorkshopsView.vue?vue&type=script&lang=ts&"
export * from "./WorkshopsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports